import { initialPagedData, PagedApiData } from '@app/core/models/PagedApiData';
import { Map } from 'immutable';

export interface TableDataState {
  dataTables: Map<string, PagedApiData<any>>;
}

export const initialTableState = (...indexes: string[]) => {
  let map = Map<string, PagedApiData<any>>();
  for (const index of indexes) {
    map = map.set(index, initialPagedData);
  }
  return map;
};
